function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5934_141437)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.7287 19.9962C26.7287 19.9962 27.5616 20.1295 25.2888 18.5613C24.4748 17.9997 23.5178 17.6846 22.5388 17.6557C21.5597 17.6268 20.6026 17.8855 19.7885 18.3991C18.9744 18.9127 18.3398 19.6581 17.965 20.541C17.5901 21.4239 17.492 22.4048 17.6828 23.3595C17.8737 24.3142 18.345 25.1998 19.0372 25.9045C19.7293 26.6091 20.6113 27.1011 21.5715 27.3182C22.5317 27.5353 23.527 27.4678 24.4316 27.1242C25.3362 26.7805 26.1094 26.1763 26.6535 25.3877",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5955 16.6676L27.2778 20.0808L23.8447 20.6545",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5181 12.4315C24.0651 8.66909 16.6839 9.90244 13.0391 15.185C9.39423 20.4676 10.8612 27.806 16.3142 31.5684C21.7672 35.3308 29.1484 34.0974 32.7933 28.8148C36.4381 23.5322 34.9711 16.1939 29.5181 12.4315Z",
  stroke: "black",
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5934_141437"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 31,
  fill: "white",
  transform: "translate(18.5493 0.155518) rotate(34.6045)"
})));

function SvgIcNextPodcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNextPodcast);
export default __webpack_public_path__ + "static/media/ic_next_podcast.8f08f325.svg";
export { ForwardRef as ReactComponent };